import { Container, Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { ButtonHLPure, DropDownBtnHLPure, SimpleLoading } from '../../pures'
import { useTranslation } from 'react-i18next';

const UserAdministrationUseAssistants = (props) => {
    const { 
        t, 
        selectedUser, 
        handleBack, 
        isEditing, 
        setIsEditing,
        getAvailableAssistants,
        getAssignedAssistants,
        assignAssistant
    } = props;
    const { t: tCommon } = useTranslation('common')
    const [availableAssistants, setAvailableAssistants] = useState([])
    const [assignedAssistants, setAssignedAssistants] = useState([])
    const [selectedAssistants, setSelectedAssistants] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    // Load assistants on component mount or when selectedUser changes
    useEffect(() => {
        if (selectedUser?.id) {
            loadAssistants()
        }
    }, [selectedUser?.id])

    const loadAssistants = async () => {
        try {
            setLoading(true)
            setError(null)

            const available = await getAvailableAssistants()
            const assigned = await getAssignedAssistants()
            
            setAvailableAssistants(available)
            setAssignedAssistants(assigned)
            setSelectedAssistants(assigned) // Guardar los objetos completos, no solo IDs
        } catch (err) {
            console.error('Error loading assistants:', err)
            setError(err.message || 'Error loading assistants')
        } finally {
            setLoading(false)
        }
    }

    const handleSaveAssistants = async () => {
        try {
            setLoading(true)
            // Extraer IDs de los objetos seleccionados
            const assistantIds = selectedAssistants.map(a => a.id)
            await assignAssistant(assistantIds)
            setIsEditing(false)
        } catch (err) {
            console.error('Error saving assistants:', err)
            setError('Error saving assistants')
        } finally {
            setLoading(false)
        }
    }

    const toggleEdit = (value) => {
        if (!value) {
            loadAssistants()
        }
        setIsEditing(value)
    }

    const handleMultiSelectChange = (e) => {
        setSelectedAssistants(e.value || [])
    }

    // Combina disponibles y asignados sin duplicados
    const allAssistants = [...availableAssistants, ...assignedAssistants]
        .filter((v, i, a) => a.findIndex(t => t.id === v.id) === i)

    // Mostrar loading si está cargando
    if (loading) {
        return (
            <Container maxWidth={"md"}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
                            <SimpleLoading />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        )
    }

    // Si no está cargando, mostrar el contenido normal
    return (
        <Container maxWidth={"md"}>
            <Grid container spacing={2}>
                {error && (
                    <Grid item xs={12}>
                        <div className="assistant-error-message">{error}</div>
                    </Grid>
                )}

                <Grid item xs={12}>
                    <h4 className="assistant-section-title">
                        {t('assistants')}
                    </h4>
                    <DropDownBtnHLPure
                        labelDropDown={t('selectAssistants')}
                        multiselect={true}
                        optionsDropDown={allAssistants}
                        onDropDownChange={handleMultiSelectChange}
                        optionsValue={selectedAssistants}
                        valueItem="id"
                        nameOption="name"
                        placeholder={tCommon('selectAssistants')}
                        disable={!isEditing || loading}
                        required={false}
                    />
                </Grid>

                <Grid item xs={12} className="button-actions">
                    {isEditing ? (
                        <>
                            <ButtonHLPure
                                colorScheme="error"
                                outlined
                                onClick={() => toggleEdit(false)}
                                nameBtn={tCommon("cancel")}
                                disabled={loading}
                            />
                            <ButtonHLPure
                                primary
                                nameBtn={tCommon("save")}
                                onClick={handleSaveAssistants}
                                disabled={loading}
                            />
                        </>
                    ) : (
                        <>
                            <ButtonHLPure
                                primary
                                outlined
                                onClick={handleBack}
                                nameBtn={tCommon("goBack")}
                            />
                            <ButtonHLPure
                                primary
                                onClick={() => toggleEdit(true)}
                                nameBtn={tCommon("edit")}
                            />
                        </>
                    )}
                </Grid>
            </Grid>
        </Container>
    )
}

export default UserAdministrationUseAssistants